import { useQuery } from "@tanstack/react-query";
import { getClientsStageSummary } from "@/services/api/agentic-v2";
import type { VisibilityScope, ClientsOnboardingScope } from "@/services/api/agentic-v2/types";
import { useWindowLive } from "@/components/ui/os-layout/WindowActiveContext";
import { clientsKeys } from "./keys";

export interface UseClientsStageSummaryOptions {
  visibility: VisibilityScope;
  onboardingScope?: ClientsOnboardingScope;
  enabled?: boolean;
}

/** Server-side caseload counts for Clients stage pills (stable across active filter). */
export function useClientsStageSummary({
  visibility,
  onboardingScope = "all",
  enabled: enabledOption = true,
}: UseClientsStageSummaryOptions) {
  const isWindowLive = useWindowLive();
  const enabled = enabledOption && isWindowLive;

  return useQuery({
    queryKey: clientsKeys.stageSummary(visibility, onboardingScope),
    enabled,
    staleTime: 60_000,
    queryFn: () => getClientsStageSummary({ visibility, onboarding_scope: onboardingScope }),
  });
}
